import { OrderStatusEnum } from 'types/graphql';
import { getShiftBiddingStatus } from 'utils/shiftStatus';

interface UseAutoExtendBidParams {
  biddable: boolean;
  autoRebid: boolean;
  sentToAgencies: boolean;
  bids: unknown[];
  status: OrderStatusEnum;
  biddingTimeEndsAt?: string;
  timeZone?: string;
}

export const useAutoExtendBid = ({
  biddable,
  autoRebid,
  sentToAgencies,
  bids,
  status,
  biddingTimeEndsAt,
  timeZone,
}: UseAutoExtendBidParams) => {
  const biddingStatus = getShiftBiddingStatus({
    status,
    biddable,
    biddingTimeEndsAt,
    bids,
    timeZone,
  });
  const isAutoBidAllowed =
    biddable &&
    !autoRebid &&
    !sentToAgencies &&
    (!Array.isArray(bids) || bids.length === 0) &&
    (biddingStatus === 'NO_BIDS' || biddingStatus === 'BIDDING');

  return {
    isAutoBidAllowed,
    shouldDisableAutoExtendBidToggle: !isAutoBidAllowed,
  };
};
